import Logger from '@yakit/core/logger'; let log = Logger(false);
import { writable, get, derived, type Readable, type Writable } from 'svelte/store'
import { _get, _set, extend, money, assign } from "@yakit/core"
import { LOADING, IDLE, ERROR, makeModelStore } from '@yakit/core/resource'
import type { DataObject, ModelStore, RestDataApi } from '@yakit/core/types';
import dataApiFactory from '~/api/dataApiFactory'
import type { ArTran } from '~/types/entities/ArTran';

//---end imports---


export interface TranModel extends ModelStore {
  apiPath: string
  cartContents: Writable<any[]>
  totalApplied: Readable<number>
  feeAmount: number
  loadActive(): void
  clear(): void
  init(): void
  get(): ArTran
}
/**
 * QueryStore for the payTran.
 */
  export function createPayTranModel(): TranModel{
  const activeModel = makeModelStore({ key: 'ar.tran' })

  const cartContents = writable([]);
  

  const {status, set, dataApi } = activeModel
  // Store reference to original get() before we override it
  const originalGet = activeModel.get.bind(activeModel)

  const totalApplied = derived( cartContents, ($cartContents) => {
    // let applied = 0
    // log("$cartContents", $cartContents)
    const total = $cartContents.reduce((acc, line) => {
      return money(acc).add(line.applyAmount).value
    }, 0);

    log("totalApplied calc", total)
    return total //applied
  });

  const balance = derived([totalApplied, activeModel.model], ([$totalApplied, $model]) => {
    console.log("balance calc", $totalApplied, $model)
    const model = $model as ArTran | null
    const calculatedFee = 0 // $totalApplied*(isVisa && 0.02)
    log("fee calc", calculatedFee)
    return calculatedFee
  })
  /**
   * Overrrides
   */
  function init() {
    //return loadActive()
  }

  function clear() {
    cartContents.set([])
    set({})
  }

  extend(activeModel, {
    init,
    cartContents,
    balance,
    //loadActive,
    totalApplied,
    clear,
    get(){
      // Use the original get() from ModelStore which returns modelData
      // modelData is set by setModel() when set() is called
      const modelData = originalGet()
      log("tranModel get", modelData)
      return modelData
    }
    // Note: Don't override set() - it causes infinite recursion
    // The activeModel already has a proper set() method from ModelStore
  } as any)

  return activeModel as TranModel
}
